export interface IExpressionConfig {
    fields: IExpressionConfigProperty
}

/**
 * Synthetic field of the Skip Timeout builder.
 * It is not a Worker/Task attribute: it produces the constant TaskRouter
 * expression `1==1` (`skip_if: "1==1"` - skip the step as soon as no matching
 * Worker is free) or no `skip_if` at all.
 * @see https://www.twilio.com/docs/taskrouter/worker-presence
 */
export const ALWAYS_FIELD = 'always'

export const ALWAYS_ON = 1
export const ALWAYS_OFF = 0

export function isAlwaysRule(rule: any): boolean {
    return rule !== undefined && rule !== null && rule.condition === undefined && rule.field === ALWAYS_FIELD
}

export function isAlwaysOn(value: string[] | string | number[] | number | boolean | undefined): boolean {
    return value === ALWAYS_ON || value === '1' || value === true || value === 'true'
}

export interface IExpressionConfigProperty {
    [key: string]: any
}
export class ExpressionConfigProperty {
    [key: string]: any
}
export class ExpressionOption {
    name: string
    value: string | number | boolean
    constructor(name:string, value:string | number | boolean){
        this.name = name
        this.value = value
    }
}
export enum ExpressionConditions{
    AND = "AND",
    OOR = "OR"
} 
export class Expression {
    public condition: ExpressionConditions = ExpressionConditions.AND
    
    public rules: ExpressionRule[] | Expression[] = []
}

export class ExpressionRule {
    public field: string

    public operator: string

    public value: string[] | string | number[] | number

    constructor(field: string, operator: string, value: string[] | string | number[] | number){
        this.field = field
        this.operator = operator
        this.value = value
    }
}